module.exports = __webpack_public_path__ + "header_green_bg.png?ed2ab7c79d743bbaef18341d72bab51a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header_green_bg.png
// module id = 564
// module chunks = 0